export const INTERNATIONAL_PHONE_NUMBER_REGEX = /^(\d*)(\d{3})(\d{3})(\d{4})$/;
export const NORTH_AMERICAN_PHONE_NUMBER_REGEX = /^(\d{3})(\d{3})(\d{4})$/;
